import { z } from 'zod';

/**
 * Legame del PG con un altro PG del gruppo.
 *
 * Le classi forniscono dei "template" di legami con placeholder per il nome
 * (es. "_____ è gracile e sciocco, ma mi fa ridere..."). Il giocatore sceglie
 * un template, lo riempie col nome di un compagno e lo aggiunge ai propri
 * legami. Quando il legame si "risolve" durante il gioco, va sostituito.
 *
 * Lo schema qui rappresenta il legame **compilato** sulla scheda PG.
 * I template vivono in ClassDefinition (PR successiva).
 */
export const BondSchema = z.object({
  /**
   * Testo finale del legame, con il nome del PG bersaglio integrato.
   * Mantenere il template originale + il targetName separato sarebbe
   * più robusto, ma per la prima iterazione lo storiamo già risolto:
   * la scheda stampata mostra esattamente quello che il giocatore ha scritto.
   */
  text: z.string().min(1).max(500),
  /** Nome del PG referenziato (utile per UI e per risolvere legami). */
  targetCharacterName: z.string().min(1).max(50).optional(),
  /**
   * Se true, il legame è stato risolto e va sostituito al fine sessione
   * (vedi mossa "Fine Sessione" nel manuale).
   */
  resolved: z.boolean().default(false),
});
export type Bond = z.infer<typeof BondSchema>;
